
window.EdgeSearch = {
  buildTitleQuery(searchTerm) {
    const words = searchTerm
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!words.length) return "";

    return words
      .map((word) => {
        const safeWord = word.replace(/["\\]/g, "");
        return `title:"${safeWord}"`;
      })
      .join(" AND ");
  },

  async hasTitleMatches(searchTerm) {
    const query = this.buildTitleQuery(searchTerm);
    if (!query) return false;

    const url = new URL("/search/suggest.json", window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("resources[limit]", "1");

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Search request failed");

      const data = await response.json();
      return (data.resources?.results?.products?.length || 0) > 0;
    } catch (error) {
      console.warn("Edge title search check failed:", error);
      return false;
    }
  }
};

window.EdgeSearch.search = async function (searchTerm) {
  const term = searchTerm.trim();
  if (!term) return;

  const words = term.split(/\s+/).filter(Boolean);
  const safeWords = words.map(word => word.replace(/["\\]/g, ""));

  const titleQuery = this.buildTitleQuery(term);

  const exactBodyQuery = `body:"${safeWords.join(" ")}"`;

  const bodyWordsQuery = safeWords
    .map(word => `body:"${word}"`)
    .join(" AND ");

  async function hasMatches(query) {
    const url = new URL("/search/suggest.json", window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("resources[limit]", "1");

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Search request failed");
    }

    const data = await response.json();

    return (data.resources?.results?.products?.length || 0) > 0;
  }

  let query = titleQuery;

  try {
    if (await hasMatches(titleQuery)) {
      query = titleQuery;
    } else if (await hasMatches(exactBodyQuery)) {
      query = exactBodyQuery;
    } else if (await hasMatches(bodyWordsQuery)) {
      query = bodyWordsQuery;
    } else {
      // Deliberately impossible title match.
      // Produces a no-results page.
      query = 'title:"edge-search-no-match-987654321"';
    }
  } catch (error) {
    console.warn("Edge search fallback error:", error);

    // On a network error, use normal Shopify search.
    query = term;
  }

  const url = new URL("/search", window.location.origin);
  url.searchParams.set("q", query);
  url.searchParams.set("edge_query", term);
  url.searchParams.set("type", "product");

  window.location.assign(url.toString());
};
// EDGE SEARCH: Display the customer's original search phrase.
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const originalQuery = params.get("edge_query");

  if (!originalQuery || !window.location.pathname.endsWith("/search")) {
    return;
  }

  const searchInput = document.querySelector("#Search-In-Template");

  if (searchInput) {
    searchInput.value = originalQuery;
  }
  // Restore the customer's original phrase in the no-results message.
const noResultsMessage = document.querySelector("#Edge-Search-No-Results");

if (noResultsMessage) {
  noResultsMessage.textContent =
    `No results found for “${originalQuery}”. Check the spelling or use a different word or phrase.`;
}
});


// EDGE SEARCH: Connect Shopify search forms to our custom search.
document.addEventListener("submit", async (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;

  const action = new URL(form.action, window.location.origin);

  if (!action.pathname.endsWith("/search")) return;

  const input = form.querySelector('input[name="q"]');
  if (!input) return;

  const term = input.value.trim();
  if (!term) return;

  // Prevent Shopify's default search submission.
  event.preventDefault();


  // Prevent duplicate submissions.
  if (form.dataset.edgeSearching === "true") return;

  form.dataset.edgeSearching = "true";

  try {
    await window.EdgeSearch.search(term);
  } catch (error) {
    console.error("Edge search error:", error);

    const url = new URL("/search", window.location.origin);
    url.searchParams.set("q", term);
    window.location.assign(url.toString());
  }
}, true);

// EDGE SEARCH: Preserve original search phrase in pagination links.
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const originalQuery = params.get("edge_query");

  if (!originalQuery || !window.location.pathname.endsWith("/search")) {
    return;
  }

  // Update search pagination links to retain the original query.
  document.querySelectorAll('a[href*="page="]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);

    if (!url.pathname.endsWith("/search")) return;

    url.searchParams.set("edge_query", originalQuery);

    link.href = url.toString();
  });
});